<app-payment-panel-stripe-generic
  [type]="paymentMethodHandles.StripeApplePay"
  [isPayButtonVisible]="false"
></app-payment-panel-stripe-generic>
